"use client";

import {useQuery} from "@tanstack/react-query";
import React from "react";

import Loading from "@/app/loading";
import FetchError from "@/components/ui/fetch-error";
import {TeamMemberProps} from "@/types";

import TeamMember from "./team-member";

import api from "@/lib/api";

export default function TeamGrid() {
  const {
    data: teamMembers = [],
    error,
    isPending,
  } = useQuery({
    queryKey: ["team-members-covid"],
    queryFn: () => api.get<TeamMemberProps[]>("/cms/team-members/core/"),
  });

  // Group members by department
  const groupedMembers = teamMembers.reduce<{
    [department: string]: TeamMemberProps[];
  }>((acc, member) => {
    const department = member.department;
    if (!acc[department]) {
      acc[department] = [];
    }
    acc[department].push(member);
    return acc;
  }, {});

  // Sort members within each department by order
  Object.keys(groupedMembers).forEach((department) => {
    groupedMembers[department].sort((a, b) => a.order - b.order);
  });

  if (isPending) return <Loading />;
  if (error) return <FetchError message={error.message} />;

  return (
    <>
      {Object.entries(groupedMembers).map(([department, departmentMembers]) => (
        <div key={department} className='mb-5'>
          <h5 className='text-uppercase text-secondary mt-4'>{department}</h5>
          <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4 g-0 container bg-light border-top border-bottom mb-4'>
            {departmentMembers.map((member, index) => (
              <TeamMember key={index} {...member} />
            ))}
          </div>
        </div>
      ))}
    </>
  );
}
